import { useApiDataService } from './use-api-data-service';
import { UserService } from 'services/user-service';

export const useUserService = () => useApiDataService<UserService>(UserService);
export default useUserService;
